import {
  Button,
  Typography,
  Grid,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";
import { useFormContext, useFieldArray } from "react-hook-form";
import {
  StyledSectionContainerGrid,
  StyledSectionInputGroupGrid,
  StyledSectionAppendableContainerGrid,
} from "./styles";

import TextField from "../../mui-components/TextField";
import Select from "../../mui-components/Select";
import { types } from "../propertyTypes";

export const PropertiesSection = ({ isDisabled }) => {
  const { control } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: "properties",
  });

  return (
    <>
      <StyledSectionContainerGrid container spacing={4}>
        <StyledSectionInputGroupGrid item xs={6}>
          <Typography variant="h6">Properties</Typography>
        </StyledSectionInputGroupGrid>
        <StyledSectionInputGroupGrid item xs={6}>
          <Button
            disabled={isDisabled}
            variant="outlined"
            color="success"
            disableRipple
            onClick={() => append({ name: "", type: "STRING", value: "" })}
          >
            Add
          </Button>
        </StyledSectionInputGroupGrid>
      </StyledSectionContainerGrid>
      {fields.map((field, index) => (
        <StyledSectionAppendableContainerGrid
          key={field.id}
          container
          spacing={4}
        >
          <StyledSectionInputGroupGrid item xs={3}>
            <TextField
              disabled={isDisabled}
              name={`properties.${index}.name`}
              label="Name"
              variant="standard"
            />
          </StyledSectionInputGroupGrid>
          <StyledSectionInputGroupGrid item xs={3}>
            <FormControl variant="standard" fullWidth>
              <InputLabel disabled={isDisabled} id="properties-type">
                Type
              </InputLabel>
              <Select
                disabled={isDisabled}
                name={`properties.${index}.type`}
                labelId="properties-type"
                label="Type"
              >
                {types?.map((type) => (
                  <MenuItem key={type.id} value={type.value}>
                    {type.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </StyledSectionInputGroupGrid>
          <StyledSectionInputGroupGrid item xs={4}>
            <TextField
              disabled={isDisabled}
              name={`properties.${index}.value`}
              label="Value"
              variant="standard"
            />
          </StyledSectionInputGroupGrid>
          <StyledSectionInputGroupGrid item xs={2}>
            <Button
              disabled={isDisabled}
              variant="outlined"
              color="error"
              disableRipple
              onClick={() => remove(index)}
            >
              Remove
            </Button>
          </StyledSectionInputGroupGrid>
        </StyledSectionAppendableContainerGrid>
      ))}
      {!fields.length && (
        <StyledSectionContainerGrid container spacing={4}>
          <Grid item>
            <Typography color="grey.500">
              No properties available, press the ADD button to add a new
              property
            </Typography>
          </Grid>
        </StyledSectionContainerGrid>
      )}
    </>
  );
};
